import { createFileRoute, redirect } from '@tanstack/react-router';

import { ROUTES } from '@/config/routes';
import { isPlatformAdmin } from '@/host/access';
import { authErrorSearch } from '@/platform/auth/auth-error-search';
import { SsoView } from '@/platform/orgs/SsoView';

export const Route = createFileRoute('/_app/platform-sso')({
   validateSearch: authErrorSearch,
   beforeLoad: ({ context }) => {
      if (!isPlatformAdmin(context.user)) throw redirect({ to: ROUTES.HOME, replace: true });
   },
   component: () => <SsoView scope="platform" />
});
